import { FaqListResponse, FaqQuery } from '@models/graphQL';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map} from 'rxjs/operators';
import { Apollo, gql, QueryRef } from 'apollo-angular';
import { FaqMapper } from '../mappers/faq/faq-mapper';


@Injectable()
export class GraphQLService {
  constructor(
    private apollo: Apollo
    ) { }

  getFaqItems(paths: string[]): Observable<FaqListResponse> {
    var variables = {};
    if (paths) {
        paths.forEach((element, index) => {
            variables[`path${(index + 1)}`] = element;
        });
    }
		
    return this.apollo.query<FaqQuery>({
      query: gql`fragment GeneralLink on LinkField {
                    text
                    url
                    target
                    queryString
                    __typename
                }
                fragment FaqItem on FaqItem {
                    id
                    question {
                        value
                        __typename
                    }
                    answer {
                        value
                        __typename
                    }
                    button {
                        ...GeneralLink
                        __typename
                    }
                    buttonStyle {
                        ... on LookupField {
                            targetItem {
                                ... on DropdownItemIpo {
                                    dropdownValue {
                                        value
                                        __typename
                                    }
                                    __typename
                                }
                                __typename
                            }
                            __typename
                        }
                        __typename
                    }
                    __typename
                }
                fragment FaqListItem on FaqList {
                    id
                    path
                    title {
                        value
                        __typename
                    }
                    link {
                        ...GeneralLink
                        __typename
                    }
                    faqCategoriesLast {
                        boolValue
                        __typename
                    }
                    maxFaqItemsFromCategories {
                        numberValue
                        __typename
                    }
                    faqCategories {
                        targetItems {
                            ... on FaqCategory {
                                title {
                                    value
                                    __typename
                                }
                                children {
                                    ... on FaqItem {
                                        ...FaqItem
                                        __typename
                                    }
                                    __typename
                                }
                                __typename
                            }
                            __typename
                        }
                        __typename
                    }
                    faqItems {
                        targetItems {
                            ... on FaqItem {
                                ...FaqItem
                                __typename
                            }
                            __typename
                        }
                        __typename
                    }
                    __typename
                }
                query FaqList($path1: String, $path2: String, $path3: String) {
                    faq1: item(path: $path1) {
                        ... on FaqList {
                            ...FaqListItem
                            __typename
                        }
                        __typename
                    }
                    faq2: item(path: $path2) {
                        ... on FaqList {
                            ...FaqListItem
                            __typename
                        }
                        __typename
                    }
                    faq3: item(path: $path3) {
                        ... on FaqList {
                            ...FaqListItem
                            __typename
                        }
                        __typename
                    }
                }  
      `, variables: variables
    }).pipe(
      map(response => {
        if (response?.data?.faq1?.id) {
          return response.data.faq1;
        }
        if (response?.data?.faq2?.id) {
          return response.data.faq2;
        }
        if (response?.data?.faq3?.id) {
          return response.data.faq3;
        }

        return response.data.faq1;
      }),
      map(faqList => FaqMapper.calculateFaqItems(faqList))
    );
  }
}
